import { render, staticRenderFns } from "./SkupPrometCreate.vue?vue&type=template&id=42e6331a&scoped=true&"
import script from "./SkupPrometCreate.vue?vue&type=script&lang=js&"
export * from "./SkupPrometCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e6331a",
  null
  
)

export default component.exports